export enum DeviceBrowser {
    OPERA = 'Opera',
    FIREFOX = 'Firefox',
    SAFARI = 'Safari',
    IE = 'IE',
    EDGE = 'Edge',
    CHROME = 'Chrome',
    BLINK = 'Blink',
    UNDEFINED = 'Undefined'
}
